// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/workspace.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Pagination, PaginationMeta } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.WorkspaceStatus
 */
export enum WorkspaceStatus {
  /**
   * @generated from enum value: WORKSPACE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSPACE_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: WORKSPACE_STATUS_SUSPENDED = 2;
   */
  SUSPENDED = 2,

  /**
   * @generated from enum value: WORKSPACE_STATUS_ARCHIVED = 3;
   */
  ARCHIVED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(WorkspaceStatus)
proto3.util.setEnumType(WorkspaceStatus, "tracker.v1.WorkspaceStatus", [
  { no: 0, name: "WORKSPACE_STATUS_UNSPECIFIED" },
  { no: 1, name: "WORKSPACE_STATUS_ACTIVE" },
  { no: 2, name: "WORKSPACE_STATUS_SUSPENDED" },
  { no: 3, name: "WORKSPACE_STATUS_ARCHIVED" },
]);

/**
 * Workspace is the tracker's record of one organization of realm customers —
 * the tenant. All other aggregates carry its workspace_id for isolation.
 *
 * @generated from message tracker.v1.Workspace
 */
export class Workspace extends Message<Workspace> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string slug = 3;
   */
  slug = "";

  /**
   * The organization (realm customers) this workspace belongs to.
   *
   * @generated from field: string org_id = 4;
   */
  orgId = "";

  /**
   * @generated from field: string default_tracking_domain_id = 5;
   */
  defaultTrackingDomainId = "";

  /**
   * @generated from field: tracker.v1.WorkspaceStatus status = 6;
   */
  status = WorkspaceStatus.UNSPECIFIED;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt = "";

  /**
   * Goal preset key that prefills new affiliate networks + report presets.
   *
   * @generated from field: string default_goal_preset = 9;
   */
  defaultGoalPreset = "";

  /**
   * IANA zone every report of this workspace counts its days in, unless the
   * request names another. Default Europe/Kyiv.
   *
   * @generated from field: string timezone = 11;
   */
  timezone = "";

  constructor(data?: PartialMessage<Workspace>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Workspace";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "org_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "default_tracking_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(WorkspaceStatus) },
    { no: 7, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "default_goal_preset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Workspace {
    return new Workspace().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Workspace {
    return new Workspace().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Workspace {
    return new Workspace().fromJsonString(jsonString, options);
  }

  static equals(a: Workspace | PlainMessage<Workspace> | undefined, b: Workspace | PlainMessage<Workspace> | undefined): boolean {
    return proto3.util.equals(Workspace, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWorkspacesRequest
 */
export class ListWorkspacesRequest extends Message<ListWorkspacesRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListWorkspacesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWorkspacesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkspacesRequest | PlainMessage<ListWorkspacesRequest> | undefined, b: ListWorkspacesRequest | PlainMessage<ListWorkspacesRequest> | undefined): boolean {
    return proto3.util.equals(ListWorkspacesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWorkspacesResponse
 */
export class ListWorkspacesResponse extends Message<ListWorkspacesResponse> {
  /**
   * @generated from field: repeated tracker.v1.Workspace items = 1;
   */
  items: Workspace[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListWorkspacesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWorkspacesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: Workspace, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkspacesResponse | PlainMessage<ListWorkspacesResponse> | undefined, b: ListWorkspacesResponse | PlainMessage<ListWorkspacesResponse> | undefined): boolean {
    return proto3.util.equals(ListWorkspacesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetWorkspaceRequest
 */
export class GetWorkspaceRequest extends Message<GetWorkspaceRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetWorkspaceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetWorkspaceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkspaceRequest {
    return new GetWorkspaceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkspaceRequest {
    return new GetWorkspaceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkspaceRequest {
    return new GetWorkspaceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkspaceRequest | PlainMessage<GetWorkspaceRequest> | undefined, b: GetWorkspaceRequest | PlainMessage<GetWorkspaceRequest> | undefined): boolean {
    return proto3.util.equals(GetWorkspaceRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetWorkspaceResponse
 */
export class GetWorkspaceResponse extends Message<GetWorkspaceResponse> {
  /**
   * @generated from field: tracker.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;

  constructor(data?: PartialMessage<GetWorkspaceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetWorkspaceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace", kind: "message", T: Workspace },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWorkspaceResponse {
    return new GetWorkspaceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWorkspaceResponse {
    return new GetWorkspaceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWorkspaceResponse {
    return new GetWorkspaceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWorkspaceResponse | PlainMessage<GetWorkspaceResponse> | undefined, b: GetWorkspaceResponse | PlainMessage<GetWorkspaceResponse> | undefined): boolean {
    return proto3.util.equals(GetWorkspaceResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateWorkspaceRequest
 */
export class UpdateWorkspaceRequest extends Message<UpdateWorkspaceRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string default_tracking_domain_id = 3;
   */
  defaultTrackingDomainId = "";

  /**
   * Empty = leave unchanged.
   *
   * @generated from field: string default_goal_preset = 4;
   */
  defaultGoalPreset = "";

  /**
   * IANA zone name; empty = leave unchanged.
   *
   * @generated from field: string timezone = 6;
   */
  timezone = "";

  constructor(data?: PartialMessage<UpdateWorkspaceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateWorkspaceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "default_tracking_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "default_goal_preset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWorkspaceRequest {
    return new UpdateWorkspaceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWorkspaceRequest {
    return new UpdateWorkspaceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWorkspaceRequest {
    return new UpdateWorkspaceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWorkspaceRequest | PlainMessage<UpdateWorkspaceRequest> | undefined, b: UpdateWorkspaceRequest | PlainMessage<UpdateWorkspaceRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWorkspaceRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateWorkspaceResponse
 */
export class UpdateWorkspaceResponse extends Message<UpdateWorkspaceResponse> {
  /**
   * @generated from field: tracker.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;

  constructor(data?: PartialMessage<UpdateWorkspaceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateWorkspaceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace", kind: "message", T: Workspace },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWorkspaceResponse {
    return new UpdateWorkspaceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWorkspaceResponse {
    return new UpdateWorkspaceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWorkspaceResponse {
    return new UpdateWorkspaceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWorkspaceResponse | PlainMessage<UpdateWorkspaceResponse> | undefined, b: UpdateWorkspaceResponse | PlainMessage<UpdateWorkspaceResponse> | undefined): boolean {
    return proto3.util.equals(UpdateWorkspaceResponse, a, b);
  }
}

/**
 * The people behind ids the tracker stores (owner_id, created_by, an actor):
 * the identity provider's subjects, named from its directory whether or not
 * the person ever signed in to the tracker.
 *
 * @generated from message tracker.v1.GetPeopleNamesRequest
 */
export class GetPeopleNamesRequest extends Message<GetPeopleNamesRequest> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<GetPeopleNamesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetPeopleNamesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPeopleNamesRequest {
    return new GetPeopleNamesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPeopleNamesRequest {
    return new GetPeopleNamesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPeopleNamesRequest {
    return new GetPeopleNamesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPeopleNamesRequest | PlainMessage<GetPeopleNamesRequest> | undefined, b: GetPeopleNamesRequest | PlainMessage<GetPeopleNamesRequest> | undefined): boolean {
    return proto3.util.equals(GetPeopleNamesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetPeopleNamesResponse
 */
export class GetPeopleNamesResponse extends Message<GetPeopleNamesResponse> {
  /**
   * id → display name; an id the directory does not know is absent.
   *
   * @generated from field: map<string, string> names = 1;
   */
  names: { [key: string]: string } = {};

  constructor(data?: PartialMessage<GetPeopleNamesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetPeopleNamesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "names", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPeopleNamesResponse {
    return new GetPeopleNamesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPeopleNamesResponse {
    return new GetPeopleNamesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPeopleNamesResponse {
    return new GetPeopleNamesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPeopleNamesResponse | PlainMessage<GetPeopleNamesResponse> | undefined, b: GetPeopleNamesResponse | PlainMessage<GetPeopleNamesResponse> | undefined): boolean {
    return proto3.util.equals(GetPeopleNamesResponse, a, b);
  }
}

/**
 * Who the caller is in his org, as the API resolved him: the SPA gates its
 * screens on this, never on token claims (a realm customers token carries
 * no tracker roles — they live in the org's entitlements, S16).
 *
 * @generated from message tracker.v1.GetCallerRequest
 */
export class GetCallerRequest extends Message<GetCallerRequest> {
  constructor(data?: PartialMessage<GetCallerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCallerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCallerRequest {
    return new GetCallerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCallerRequest {
    return new GetCallerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCallerRequest {
    return new GetCallerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCallerRequest | PlainMessage<GetCallerRequest> | undefined, b: GetCallerRequest | PlainMessage<GetCallerRequest> | undefined): boolean {
    return proto3.util.equals(GetCallerRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetCallerResponse
 */
export class GetCallerResponse extends Message<GetCallerResponse> {
  /**
   * @generated from field: string sub = 1;
   */
  sub = "";

  /**
   * @generated from field: string email = 2;
   */
  email = "";

  /**
   * @generated from field: string org_id = 3;
   */
  orgId = "";

  /**
   * @generated from field: string org_slug = 4;
   */
  orgSlug = "";

  /**
   * The org's workspace name.
   *
   * @generated from field: string org_name = 5;
   */
  orgName = "";

  /**
   * tracker-admin | tracker-team-lead | tracker-member | tracker-viewer; ""
   * for a caller with only a platform grant.
   *
   * @generated from field: string role = 6;
   */
  role = "";

  /**
   * @generated from field: bool can_write = 7;
   */
  canWrite = false;

  /**
   * @generated from field: bool can_manage = 8;
   */
  canManage = false;

  /**
   * @generated from field: bool is_admin = 9;
   */
  isAdmin = false;

  /**
   * Platform-wide screens (IP intel, the shared edge) — our staff only.
   *
   * @generated from field: bool is_platform_admin = 10;
   */
  isPlatformAdmin = false;

  /**
   * The overlay rollouts and kill switches of the shared edge.
   *
   * @generated from field: bool is_edge_operator = 11;
   */
  isEdgeOperator = false;

  /**
   * The visibility scope (vibe-common auth.Scope): "self" — the person sees
   * only his own campaigns, offers and their numbers, no other people (no
   * «по байерам», no owner picker) and only the screens of his own work;
   * "org" — the whole workspace, as before.
   *
   * @generated from field: string scope = 12;
   */
  scope = "";

  constructor(data?: PartialMessage<GetCallerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCallerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sub", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "org_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "org_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "org_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "can_write", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "can_manage", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "is_platform_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "is_edge_operator", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCallerResponse {
    return new GetCallerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCallerResponse {
    return new GetCallerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCallerResponse {
    return new GetCallerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCallerResponse | PlainMessage<GetCallerResponse> | undefined, b: GetCallerResponse | PlainMessage<GetCallerResponse> | undefined): boolean {
    return proto3.util.equals(GetCallerResponse, a, b);
  }
}

